import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CopounDetailsComponent } from './pages/copoun-details/copoun-details.component';
import { CopounListComponent } from './pages/copoun-list/copoun-list.component';
import { CopounComponent } from './copoun.component';

const routes: Routes = [
  {
    path: '',
    component: CopounComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'copoun-list' },
      { path: 'copoun-list', component: CopounListComponent },
      { path: '0', component: CopounDetailsComponent },
      { path: ':id', component: CopounDetailsComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CopounRoutingModule {}
